import React, { Fragment } from 'react';
import TenantItemwiseView from './TenantItemwiseView';

// Thin route entry — the V3 shell lives inside the view.
const TenantItemwiseReport = () => (
    <Fragment>
        <TenantItemwiseView />
    </Fragment>
);

export default TenantItemwiseReport;
